import { render, staticRenderFns } from "./PopupAddSetup.vue?vue&type=template&id=b0f62644&scoped=true&"
import script from "./PopupAddSetup.vue?vue&type=script&lang=js&"
export * from "./PopupAddSetup.vue?vue&type=script&lang=js&"
import style0 from "./PopupAddSetup.vue?vue&type=style&index=0&id=b0f62644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f62644",
  null
  
)

export default component.exports